'use client';
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Susy = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../hooks");
const _1 = require("./");
const SusyGrid = styled_components_1.default.div `
  ${(0, _1.designGrid)({})}
  bottom: 0;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  user-select: none;
  z-index: 9999;
`;
const Column = styled_components_1.default.span `
  background-color: rgba(76, 0, 255, 0.01);
  border: 1px solid rgba(85, 0, 255, 0.08);
  grid-area: ${({ $columnIndex }) => `${1}/${$columnIndex + 1}/${2}/${$columnIndex + 1}`};
`;
const getColumns = (isMobile = undefined) => {
    const columns = isMobile ? 6 : 12;
    const array = [];
    for (let idx = 0; idx < columns; idx++) {
        array.push((0, jsx_runtime_1.jsx)(Column, { "$columnIndex": idx }, idx));
    }
    return array;
};
const Susy = () => {
    const { isMobile } = (0, hooks_1.useDeviceType)();
    const isMount = (0, hooks_1.useMount)();
    const Columns = (0, react_1.useMemo)(() => getColumns(isMobile), [isMobile]);
    return ((0, jsx_runtime_1.jsx)(SusyGrid, Object.assign({ className: 'susy' }, { children: isMount && Columns })));
};
exports.Susy = Susy;
